import { render } from "./MergedIndexView.vue?vue&type=template&id=f24354aa&scoped=true"
import script from "./MergedIndexView.vue?vue&type=script&lang=js"
export * from "./MergedIndexView.vue?vue&type=script&lang=js"

import "./MergedIndexView.vue?vue&type=style&index=0&id=f24354aa&lang=scss&scoped=true"

import exportComponent from "/root/workspace/tang-h5_cUXP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f24354aa"]])

export default __exports__